import { useCasinoContext } from './containers/CasinoContextProvider'
import { capitalizeFirstLetter } from './cs-connect/Utils'

export default function Dashboard() {

	const { casino, isSuperAdmin, role } = useCasinoContext()
	return (
		<div>
			<p>Name: {casino.name}</p>
			<p>Level: {isSuperAdmin ? 'Super Admin' : capitalizeFirstLetter(role.level)}</p>
			<p>Casino Id: {casino.id}</p>
		</div>
	)
}
